import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { HttpClientProvider } from '@services/http/client/http-client-provider';
import { articleType } from '@services/http/remote-calls/snf-api/articles/article.type';
import { GetArticlesRemoteCall } from '@services/http/remote-calls/snf-api/articles/get-articles.http-remote-call';
import { MappedCards } from '@components/news-eventi/mapped-cards/mapped-cards';
import classNames from 'classnames';
import { PageHead } from '../../components/common/head/page-head';
import { Navbar } from '../../components/common/navbar/navbar';
import styles from './news-eventi.module.css';
import { useSiteData } from '../../context/site-data-context';

export default function NewsEventi() {
  const intl = useIntl();
  const { serviceCategories, technologyCategories } = useSiteData();
  const [newsEvents, setNewsEvents] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const httpClient = HttpClientProvider.getInstance();
      const newsEventsRemoteCall = new GetArticlesRemoteCall(intl.locale, [
        articleType.NEWS,
        articleType.EVENT
      ]);
      const data = await httpClient.execute(newsEventsRemoteCall);
      if (!cancelled) setNewsEvents(data);
    })();
    return () => {
      cancelled = true;
    };
  }, [intl.locale]);

  return (
    <>
      <PageHead
        title={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - An IBM company - News ed eventi',
          description: 'News ed eventi - Page title'
        })}
        description={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - News ed eventi',
          description: 'News ed eventi - Page description'
        })}
      />
      <Navbar
        navCssClasses={classNames(styles.navbarBackground, 'position-fixed')}
        navLinkCssClasses={styles.navItem}
        serviceCategories={serviceCategories}
        technologyCategories={technologyCategories}
      />

      <main role="main" className="mt-5">
        <div className={`snf-font-32 snf-font-w6 px-5 pb-3 ${styles.pageHeader}`}>
          {intl.formatMessage({ defaultMessage: 'News ed eventi' })}
        </div>

        <div
          className={`snf-bg-color-prussian-blue text-white snf-font-20 px-5 text-uppercase ${
            styles.strisciaBlu
          }`}
        >
          {intl.formatMessage({ defaultMessage: 'Questo mese' })}
        </div>

        <div className="mb-5 pb-5 px-5" style={{ marginTop: '-5rem' }}>
          <MappedCards subsection="QuestoMese" data={newsEvents} />
        </div>

        <div className={`snf-font-20 px-5 pt-4 text-uppercase ${styles.subHeader}`}>Highlights</div>
        <div className="mb-5 pb-5 px-5">
          <MappedCards subsection="Highligths" data={newsEvents} />
        </div>
      </main>
    </>
  );
}
